import React, { useMemo, useCallback } from 'react';

import moment from 'moment';

import Item from './Item';
import { Container, Day, List } from './styles';

export interface Expense {
  id: string;
  date: Date;
  name: string;
  value: number;
  currency: string;
  fromRappi: boolean;
  type: 'Food' | 'Transport' | 'Accommodation' | 'Others';
}

interface GroupedExpense {
  date: Date;
  expenses: Expense[];
}

interface Props {
  expenses: Expense[];
  currentExpenses?: string[];
  isSelectable?: boolean;
  onSelect: (expense: Expense) => void;
}

const ExpensesSelectableList = ({ expenses, currentExpenses, isSelectable, onSelect }: Props) => {
  const getDayOfWeek = useCallback((date: Date) => {
    const splitDate = (date: Date) => date.toString().split('T').first();

    const formatDate = (date: Date) => {
      const dateSplited = splitDate(date);
      return dateSplited && moment(dateSplited).format();
    };

    const newDate = formatDate(date);
    return moment(newDate).format('DD/MM[,] dddd').toLowerCase();
  }, []);

  const expensesGroupedByDay = useMemo(
    () =>
      expenses.reduce((acc: GroupedExpense[], curr: Expense) => {
        const dateInArray = acc.find((item) => moment(item.date).isSame(curr.date, 'day'));
        if (dateInArray) {
          dateInArray.expenses.push(curr);
        } else {
          acc.push({
            date: curr.date,
            expenses: [curr],
          });
        }
        return acc;
      }, []),
    [expenses],
  );

  const verifyIfItemIsChecked = useCallback(
    (expense: Expense) => !!currentExpenses?.find((item) => item === expense.id),
    [currentExpenses],
  );

  return (
    <Container>
      {expensesGroupedByDay.map((dayGroup) => (
        <List key={dayGroup.date.toString()}>
          <Day>{getDayOfWeek(dayGroup.date)}</Day>
          {dayGroup.expenses.map((expense, index) => (
            <Item
              key={index}
              expense={expense}
              isSelectable={isSelectable}
              isChecked={verifyIfItemIsChecked(expense)}
              onSelect={onSelect}
            />
          ))}
        </List>
      ))}
    </Container>
  );
};

export default ExpensesSelectableList;
